import { useMutation } from "react-query";
import http from "infra/http";
import { ImpostoForm } from '../typings/index';


function useGetPutImposto(id: string) {
    return useMutation(
        (data: ImpostoForm) => {
            if (id) {
                return http.put(`/v1/imposto/${id}`, data);
            }
            return http.post(`/v1/imposto`, data);
        },
        { retry: false }
    );
}

export default useGetPutImposto;
